export default {
  loadingConversation: {
    id: 'shopping_assistant_loading_conversation_skeleton',
    defaultMessage: 'Loading conversation…',
  },
} as const
